/**
 * 公共函数
 */

import _ from 'lodash';
import moment from 'moment';
import { getPreRegisPrice } from '@/api/doctor';
import { Utils } from '@/utils/utils.js';
import { isArray ,isNull} from '@/utils/validateBase'
class Common {
    static startOfDay(time) {
        return _.toString(moment(time).startOf('day'))
    }

    static endOfDay(time) {

        return _.toString(moment(time).endOf('day'))
    }
    static timeFormat(time) {
        return _.toString(moment(time).format('yyyy-MM-DD'))
    }
    static timeFormatMM(time) {
            return _.toString(moment(time).format('MM-DD'))
        }
        //获取医生挂号费
    static getDoctorRegisPrice(obj) {
        return new Promise((resolve, reject) => {
            getPreRegisPrice(obj).then(res => {
                if (res.code == 200) {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })

    }

    static nameChange(list, type) {
        if (type == 1) {
            return list.map(kid => {
                return {
                    ...kid,
                    itemId: kid.spuId,
                    itemName: kid.spuCommonName,
                    itemNum: kid.number,
                    itemUnit: kid.unit,
                    price: kid.price,
                    inventory: kid.inventory,
                    handling: kid.handling,
                    deleteShow: false,
                    oldDrugName: kid.drugName,
                    isOwned: isNull(kid.isOwned) ? '0' : kid.isOwned,
                    medicalInsuranceType: kid.medicalInsuranceType,
                }
            })
        }
        if (type == 2) {
            return list.map(kid => {
                return {
                    ...kid,
                    drugId: kid.itemId,
                    drugName: kid.itemName,
                    id: kid.artNo,
                    number: kid.itemNum,
                    unit: kid.itemUnit,
                    price: kid.price,
                    drugKindId: kid.drugKindId || '',
                    inventory: kid.inventory,
                    handling: kid.handling,
                    deleteShow: false,
                    oldDrugName: kid.itemName,
                    isOwned: isNull(kid.isOwned) ? '0' : kid.isOwned,
                    medicalInsuranceType: kid.medicalInsuranceType,
                }
            })
        }
    }

    static computeTotalPrice(drug, phy, chineseMedicineItem, other, actList, price) {
        if (!isArray(drug)) return; //判断drug是否为数组
        let drugTotal = 0;
        drug.forEach(val => {
            val.items && val.items.forEach(k => {
                let kidSum = 0
                if (k.isOwned && k.isOwned == '0') {
                    kidSum = Utils.bigNumber(Utils.bigNumber(k.price || 0, '*', k.itemNum || 0), "*", (val.doseNum || 1), 2)
                }
                drugTotal = Utils.bigNumber(drugTotal, '+', kidSum)
            })
            if (val.processFlag == '1') {
                if (val.isYlcp == '1' && !val.isOldYl) {
                    drugTotal = Utils.bigNumber(Utils.bigNumber(val.process.processPrice, '*', val.doseNum), '+', drugTotal)
                } else {
                    drugTotal = Utils.bigNumber(val.process.processPrice, '+', drugTotal)
                }
            }
            // drugTotal = Utils.bigNumber(drugTotal, '+', val.kidSum)
        })

        if (!isArray(phy)) return; //判断phy是否为数组
        let phyTotal = phy.reduce((sum, val) => {
            let pSum = val.items.reduce((s, p) => {
                return Utils.bigNumber(s, '+', Utils.bigNumber(p.price || 0, '*', p.itemNum || 0, 2))
            }, 0)
            return Utils.bigNumber(sum, '+', pSum)
        }, 0)
        if (!isArray(chineseMedicineItem)) return; //判断chineseMedicineItem是否为数组
        let chineseMedicineTotal = chineseMedicineItem.reduce((sum, val) => {
            let cSum = val.items.reduce((s, p) => {
                return Utils.bigNumber(s, '+', Utils.bigNumber(p.price || 0, '*', p.itemNum || 0, 2))
            }, 0)
            return Utils.bigNumber(sum, '+', cSum)
        }, 0)
        let otherTotal = 0;
        if (!_.isEmpty(other.items)) {
            otherTotal = other.items.reduce((sum, val) => {
                return Utils.bigNumber(sum, '+', Utils.bigNumber(val.price || 0, '*', val.itemNum || 0, 2))
            }, 0)

        }
        let actTotal = actList && actList.reduce((total, act) => {
            return Utils.bigNumber(total, '+', act.totalPrice)
        }, 0) || 0

        let totalPrice = Utils.bigNumber(Utils.bigNumber(drugTotal, '+', phyTotal), '+', otherTotal)
        totalPrice = Utils.bigNumber(chineseMedicineTotal, '+', totalPrice)
        totalPrice = Utils.bigNumber(actTotal, '+', totalPrice)
        if (price) {
            totalPrice = Utils.bigNumber(totalPrice, '+', price)
        }
        return totalPrice
    }

    static addSearch(list, type) {
        if (type == 'drug') {
            return list.push({
                itemName: '',
                itemNum: '',
                itemUnit: 'g',
                deleteShow: false, //是否显示删除icon
                handling: '',
            })
        } else if (type == 'physio') {
            return list.push({
                itemId: '',
                itemName: ''
            })
        } else if (type == 'other') {
            return list.push({
                itemId: '',
                itemName: ''
            })
        }
    }
    static filterDiagnosis(list, type) {
        if (type == 'drug') {
            return list.filter(val => val.projectType == 0 && val.recipeType == 1)
        } else if (type == 'phy') {
            return list.filter(val => val.projectType == 0 && val.recipeType == 3)
        } else if (type == 'chineseMedicine') {
            return list.filter(val => val.projectType == 0 && val.recipeType == 4)
        } else if (type == 'other') {
            return list.filter(val => val.projectType == 1 && val.recipeType == 0)
        }
    }
}
export { Common }